import { Divider, Typography } from "@drone-js/core";
import { Title } from "apps/batchOnboarding/Title";
import { VStack } from "apps/commons/components/Stack";
import { PayoutHeader } from "apps/oneOnboarding/pricing/PayoutHeader";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { usePropertyContext } from "apps/oneOnboarding/usePropertyContext";
import { batchPricingBinder } from "libs/analytics/binders/batchOnboarding/batchPricing";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useFormContext, useWatch } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";
import { BatchDiscountController } from "./BatchDiscountController";
import { BatchPayoutController } from "./BatchPayoutController";
import { BatchRateController } from "./BatchRateController";

export const PricingPage = () => {
    const {
        cmsData: {
            pricing: { pricing, boostBookingsWithDiscounts },
        },
    } = useStaticDataAtomValue();
    const { control } = useFormContext<BulkPropertyFormData>();
    const propertyId = useWatch<BulkPropertyFormData>({
        control,
        name: "propertyDataList.0.propertyId",
    }) as BulkPropertyFormData["propertyDataList"][number]["propertyId"];
    const onboardingId = useWatch<BulkPropertyFormData>({
        control,
        name: "propertyDataList.0.onboardingId",
    }) as BulkPropertyFormData["propertyDataList"][number]["onboardingId"];
    const {
        experimentsAtom: { isFirstOpenAllotmentDate },
    } = usePropertyContext(propertyId, onboardingId ?? undefined);

    useAnalytics(batchPricingBinder);

    return (
        <VStack gap="24" pb="32">
            <Title title={pricing} />
            <BatchRateController isFirstOpenAllotmentDate={isFirstOpenAllotmentDate} />
            <Divider />
            <Typography variant="heading-default">{boostBookingsWithDiscounts}</Typography>
            <BatchDiscountController />
            <Divider />
            <PayoutHeader />
            <BatchPayoutController />
        </VStack>
    );
};
